import React from "react";
import { Tooltip } from "react-tippy";
import { ParseDate, ParseDateTime } from "../../../../../../helpers/Parsers";

import styles from "./TemplateTagsTableItem.module.scss";
import i18n from "i18next";

const tooltipStyle = {
  background: "#FFFFFF",
  boxShadow: "0px 3px 6px #00000029",
  height: "45px",
  padding: "0 15px",
  color: "#494F66",
  fontFamily: "Roboto-Light",
  fontSize: "18px",
  borderRadius: "15px",
  display: "flex",
  alignItems: "center",
};

const mapping = {
  BOX: i18n.t("box").toUpperCase(),
  PALLET: i18n.t("pallet").toUpperCase(),
  PRODUCT: i18n.t("product").toUpperCase()
};

export const TemplateTagsTable = ({
  itemTag,
  handleClick,
}) => {
  const height_width = itemTag.height ? `${i18n.t("height")} ${itemTag.height} mm | ${i18n.t("width")} ${itemTag.width} mm` : '';

  return (
    <div
      className={styles["template-tags-table-item-container"]}
      data-automation-id="product-item"
    >
      <div
        className={styles["table-item-name"]}
        data-itemtag-id={itemTag.id}
        onClick={handleClick}
      >
        <Tooltip
          html={<div style={tooltipStyle}>{itemTag.name}</div>}
          title={itemTag.name}
          followCursor={true}
          position="left"
          offset={25}
        >
          {" "}
          <p>{itemTag.name}</p>
        </Tooltip>
      </div>
      <div
        className={styles["table-item-description"]}
        data-itemtag-id={itemTag.id}
        onClick={handleClick}
      >
        <Tooltip
          html={<div style={tooltipStyle}>{itemTag.description}</div>}
          title={itemTag.description}
          followCursor={true}
          position="left"
          offset={25}
        >
          {" "}
          <p>{itemTag.description}</p>
        </Tooltip>
      </div>
      <div
        className={styles["table-item-date"]}
        data-itemtag-id={itemTag.id}
        onClick={handleClick}
      >
        <Tooltip
          html={
            <div style={tooltipStyle}>
              {itemTag.created_at
                ? ParseDateTime(itemTag.created_at)
                : null}
            </div>
          }
          title={itemTag.created_at
            ? ParseDateTime(itemTag.created_at)
            : null}
          followCursor={true}
          position="left"
          offset={25}
        >
          {" "}
          <p>{itemTag.created_at ? ParseDate(itemTag.created_at) : "-"}</p>
        </Tooltip>
      </div>
      <div
        className={styles["table-item-type"]}
        data-itemtag-id={itemTag.id}
        onClick={handleClick}
      >
        <Tooltip
          html={<div style={tooltipStyle}>{mapping[itemTag.type]}</div>}
          followCursor={true}
          position="left"
          offset={25}
        >
          <p className={styles["tag-pill"]}>{ mapping[itemTag.type] }</p>
        </Tooltip>
      </div>
      <div
        className={styles["table-item-dimensions"]}
        data-itemtag-id={itemTag.id}
        onClick={handleClick}
      >
        <Tooltip
          html={<div style={tooltipStyle}>{height_width}</div>}
          followCursor={true}
          position="right"
          offset={25}
        >
          <p>
            {height_width}
          </p>
        </Tooltip>
      </div>
      <div
        className={styles["table-item-memories"]}
        data-itemtag-id={itemTag.id}
        onClick={handleClick}
      >
        <Tooltip
          html={<div style={tooltipStyle}>{itemTag.mem_epc + "GB | " + itemTag.mem_user + "GB"}</div>}
          followCursor={true}
          position="right"
          offset={25}
        >
          <p>
            {itemTag.mem_epc + "GB | " + itemTag.mem_user + "GB"}
          </p>
        </Tooltip>
      </div>
      <div
        className={styles["table-item-button"]}
        data-automation-id="select-templateTag"
        data-itemtag-id={itemTag.id}
        onClick={handleClick}
      >
        <i className={styles["icon-chevron-derecha"]}></i>
      </div>
    </div>
  );
};

export default TemplateTagsTable;

